import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import incidentals from './incidentals'
import otaNoShow from './ota-no-show'
import virtualCard from './virtual-card'
import payments from './payments'
import changeRoom from './change-room'
import changeRoomType from './change-room-type'
import items from './items'
import activities from './activities'
/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
export const roomAvailability = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomAvailability.url(options),
    method: 'get',
})

roomAvailability.definition = {
    methods: ["get","head"],
    url: '/bookings/room-availability',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
roomAvailability.url = (options?: RouteQueryOptions) => {
    return roomAvailability.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
roomAvailability.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomAvailability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
roomAvailability.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: roomAvailability.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
const roomAvailabilityForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomAvailability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
roomAvailabilityForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomAvailability.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomAvailability
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:312
* @route '/bookings/room-availability'
*/
roomAvailabilityForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomAvailability.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

roomAvailability.form = roomAvailabilityForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
export const roomPricing = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomPricing.url(options),
    method: 'get',
})

roomPricing.definition = {
    methods: ["get","head"],
    url: '/bookings/room-pricing',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
roomPricing.url = (options?: RouteQueryOptions) => {
    return roomPricing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
roomPricing.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomPricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
roomPricing.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: roomPricing.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
const roomPricingForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomPricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
roomPricingForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomPricing.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::roomPricing
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:38
* @route '/bookings/room-pricing'
*/
roomPricingForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomPricing.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

roomPricing.form = roomPricingForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
export const getAvailableRooms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getAvailableRooms.url(options),
    method: 'get',
})

getAvailableRooms.definition = {
    methods: ["get","head"],
    url: '/bookings/get-available-rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
getAvailableRooms.url = (options?: RouteQueryOptions) => {
    return getAvailableRooms.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
getAvailableRooms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: getAvailableRooms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
getAvailableRooms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: getAvailableRooms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
const getAvailableRoomsForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getAvailableRooms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
getAvailableRoomsForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getAvailableRooms.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::getAvailableRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:77
* @route '/bookings/get-available-rooms'
*/
getAvailableRoomsForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: getAvailableRooms.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

getAvailableRooms.form = getAvailableRoomsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::calculatePricing
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:81
* @route '/bookings/calculate-pricing'
*/
export const calculatePricing = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculatePricing.url(options),
    method: 'post',
})

calculatePricing.definition = {
    methods: ["post"],
    url: '/bookings/calculate-pricing',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::calculatePricing
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:81
* @route '/bookings/calculate-pricing'
*/
calculatePricing.url = (options?: RouteQueryOptions) => {
    return calculatePricing.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::calculatePricing
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:81
* @route '/bookings/calculate-pricing'
*/
calculatePricing.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: calculatePricing.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::calculatePricing
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:81
* @route '/bookings/calculate-pricing'
*/
const calculatePricingForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: calculatePricing.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::calculatePricing
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:81
* @route '/bookings/calculate-pricing'
*/
calculatePricingForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: calculatePricing.url(options),
    method: 'post',
})

calculatePricing.form = calculatePricingForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/bookings',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::index
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:55
* @route '/bookings'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/bookings/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::create
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:126
* @route '/bookings/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::store
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:245
* @route '/bookings'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/bookings',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::store
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:245
* @route '/bookings'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::store
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:245
* @route '/bookings'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::store
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:245
* @route '/bookings'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::store
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:245
* @route '/bookings'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
export const show = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
show.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return show.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
show.get = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
show.head = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
const showForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
showForm.get = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::show
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:709
* @route '/bookings/{booking}'
*/
showForm.head = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
export const edit = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
edit.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return edit.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
edit.get = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
edit.head = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
const editForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
editForm.get = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::edit
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:374
* @route '/bookings/{booking}/edit'
*/
editForm.head = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::update
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:573
* @route '/bookings/{booking}'
*/
export const update = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/bookings/{booking}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::update
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:573
* @route '/bookings/{booking}'
*/
update.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return update.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::update
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:573
* @route '/bookings/{booking}'
*/
update.put = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::update
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:573
* @route '/bookings/{booking}'
*/
const updateForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::update
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:573
* @route '/bookings/{booking}'
*/
updateForm.put = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
export const availableRooms = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRooms.url(args, options),
    method: 'get',
})

availableRooms.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/available-rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
availableRooms.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return availableRooms.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
availableRooms.get = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
availableRooms.head = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: availableRooms.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
const availableRoomsForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
availableRoomsForm.get = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::availableRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:43
* @route '/bookings/{booking}/available-rooms'
*/
availableRoomsForm.head = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: availableRooms.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

availableRooms.form = availableRoomsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
export const assignedRooms = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assignedRooms.url(args, options),
    method: 'get',
})

assignedRooms.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/assigned-rooms',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
assignedRooms.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return assignedRooms.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
assignedRooms.get = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: assignedRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
assignedRooms.head = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: assignedRooms.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
const assignedRoomsForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignedRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
assignedRoomsForm.get = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignedRooms.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::assignedRooms
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:598
* @route '/bookings/{booking}/assigned-rooms'
*/
assignedRoomsForm.head = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: assignedRooms.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

assignedRooms.form = assignedRoomsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkin
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:212
* @route '/bookings/{booking}/checkin'
*/
export const checkin = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkin.url(args, options),
    method: 'post',
})

checkin.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/checkin',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkin
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:212
* @route '/bookings/{booking}/checkin'
*/
checkin.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return checkin.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkin
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:212
* @route '/bookings/{booking}/checkin'
*/
checkin.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkin.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkin
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:212
* @route '/bookings/{booking}/checkin'
*/
const checkinForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkin.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkin
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:212
* @route '/bookings/{booking}/checkin'
*/
checkinForm.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkin.url(args, options),
    method: 'post',
})

checkin.form = checkinForm

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkout
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:491
* @route '/bookings/{booking}/checkout'
*/
export const checkout = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkout.url(args, options),
    method: 'post',
})

checkout.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/checkout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkout
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:491
* @route '/bookings/{booking}/checkout'
*/
checkout.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return checkout.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkout
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:491
* @route '/bookings/{booking}/checkout'
*/
checkout.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: checkout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkout
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:491
* @route '/bookings/{booking}/checkout'
*/
const checkoutForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\CheckInController::checkout
* @see app/Http/Controllers/Admin/Bookings/CheckInController.php:491
* @route '/bookings/{booking}/checkout'
*/
checkoutForm.post = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: checkout.url(args, options),
    method: 'post',
})

checkout.form = checkoutForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::cancel
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:774
* @route '/bookings/{booking}/cancel'
*/
export const cancel = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

cancel.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/cancel',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::cancel
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:774
* @route '/bookings/{booking}/cancel'
*/
cancel.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return cancel.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::cancel
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:774
* @route '/bookings/{booking}/cancel'
*/
cancel.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::cancel
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:774
* @route '/bookings/{booking}/cancel'
*/
const cancelForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::cancel
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:774
* @route '/bookings/{booking}/cancel'
*/
cancelForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, options),
    method: 'post',
})

cancel.form = cancelForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::noShow
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:802
* @route '/bookings/{booking}/no-show'
*/
export const noShow = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: noShow.url(args, options),
    method: 'post',
})

noShow.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/no-show',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::noShow
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:802
* @route '/bookings/{booking}/no-show'
*/
noShow.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return noShow.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::noShow
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:802
* @route '/bookings/{booking}/no-show'
*/
noShow.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: noShow.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::noShow
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:802
* @route '/bookings/{booking}/no-show'
*/
const noShowForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: noShow.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::noShow
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:802
* @route '/bookings/{booking}/no-show'
*/
noShowForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: noShow.url(args, options),
    method: 'post',
})

noShow.form = noShowForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPayment
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:475
* @route '/bookings/{booking}/collect-payment'
*/
export const collectPayment = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectPayment.url(args, options),
    method: 'post',
})

collectPayment.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/collect-payment',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPayment
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:475
* @route '/bookings/{booking}/collect-payment'
*/
collectPayment.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return collectPayment.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPayment
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:475
* @route '/bookings/{booking}/collect-payment'
*/
collectPayment.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectPayment.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPayment
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:475
* @route '/bookings/{booking}/collect-payment'
*/
const collectPaymentForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectPayment.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPayment
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:475
* @route '/bookings/{booking}/collect-payment'
*/
collectPaymentForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectPayment.url(args, options),
    method: 'post',
})

collectPayment.form = collectPaymentForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::sendPaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1117
* @route '/bookings/{booking}/send-payment-link'
*/
export const sendPaymentLink = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendPaymentLink.url(args, options),
    method: 'post',
})

sendPaymentLink.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/send-payment-link',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::sendPaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1117
* @route '/bookings/{booking}/send-payment-link'
*/
sendPaymentLink.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return sendPaymentLink.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::sendPaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1117
* @route '/bookings/{booking}/send-payment-link'
*/
sendPaymentLink.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: sendPaymentLink.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::sendPaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1117
* @route '/bookings/{booking}/send-payment-link'
*/
const sendPaymentLinkForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendPaymentLink.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::sendPaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1117
* @route '/bookings/{booking}/send-payment-link'
*/
sendPaymentLinkForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: sendPaymentLink.url(args, options),
    method: 'post',
})

sendPaymentLink.form = sendPaymentLinkForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::generatePaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1208
* @route '/bookings/{booking}/generate-payment-link'
*/
export const generatePaymentLink = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generatePaymentLink.url(args, options),
    method: 'post',
})

generatePaymentLink.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/generate-payment-link',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::generatePaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1208
* @route '/bookings/{booking}/generate-payment-link'
*/
generatePaymentLink.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return generatePaymentLink.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::generatePaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1208
* @route '/bookings/{booking}/generate-payment-link'
*/
generatePaymentLink.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: generatePaymentLink.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::generatePaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1208
* @route '/bookings/{booking}/generate-payment-link'
*/
const generatePaymentLinkForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: generatePaymentLink.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::generatePaymentLink
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1208
* @route '/bookings/{booking}/generate-payment-link'
*/
generatePaymentLinkForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: generatePaymentLink.url(args, options),
    method: 'post',
})

generatePaymentLink.form = generatePaymentLinkForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:610
* @route '/bookings/{booking}/refund'
*/
export const refund = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refund.url(args, options),
    method: 'post',
})

refund.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/refund',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:610
* @route '/bookings/{booking}/refund'
*/
refund.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return refund.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:610
* @route '/bookings/{booking}/refund'
*/
refund.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: refund.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:610
* @route '/bookings/{booking}/refund'
*/
const refundForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refund.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::refund
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:610
* @route '/bookings/{booking}/refund'
*/
refundForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: refund.url(args, options),
    method: 'post',
})

refund.form = refundForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:42
* @route '/bookings/{booking}/collect-deposit'
*/
export const collectDeposit = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectDeposit.url(args, options),
    method: 'post',
})

collectDeposit.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/collect-deposit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:42
* @route '/bookings/{booking}/collect-deposit'
*/
collectDeposit.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return collectDeposit.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:42
* @route '/bookings/{booking}/collect-deposit'
*/
collectDeposit.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectDeposit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:42
* @route '/bookings/{booking}/collect-deposit'
*/
const collectDepositForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectDeposit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:42
* @route '/bookings/{booking}/collect-deposit'
*/
collectDepositForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectDeposit.url(args, options),
    method: 'post',
})

collectDeposit.form = collectDepositForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPaymentWithDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:147
* @route '/bookings/{booking}/collect-payment-with-deposit'
*/
export const collectPaymentWithDeposit = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectPaymentWithDeposit.url(args, options),
    method: 'post',
})

collectPaymentWithDeposit.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/collect-payment-with-deposit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPaymentWithDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:147
* @route '/bookings/{booking}/collect-payment-with-deposit'
*/
collectPaymentWithDeposit.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return collectPaymentWithDeposit.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPaymentWithDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:147
* @route '/bookings/{booking}/collect-payment-with-deposit'
*/
collectPaymentWithDeposit.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: collectPaymentWithDeposit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPaymentWithDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:147
* @route '/bookings/{booking}/collect-payment-with-deposit'
*/
const collectPaymentWithDepositForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectPaymentWithDeposit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::collectPaymentWithDeposit
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:147
* @route '/bookings/{booking}/collect-payment-with-deposit'
*/
collectPaymentWithDepositForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: collectPaymentWithDeposit.url(args, options),
    method: 'post',
})

collectPaymentWithDeposit.form = collectPaymentWithDepositForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::handleDepositCheckout
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:304
* @route '/bookings/{booking}/handle-deposit-checkout'
*/
export const handleDepositCheckout = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: handleDepositCheckout.url(args, options),
    method: 'post',
})

handleDepositCheckout.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/handle-deposit-checkout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::handleDepositCheckout
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:304
* @route '/bookings/{booking}/handle-deposit-checkout'
*/
handleDepositCheckout.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return handleDepositCheckout.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::handleDepositCheckout
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:304
* @route '/bookings/{booking}/handle-deposit-checkout'
*/
handleDepositCheckout.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: handleDepositCheckout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::handleDepositCheckout
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:304
* @route '/bookings/{booking}/handle-deposit-checkout'
*/
const handleDepositCheckoutForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: handleDepositCheckout.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::handleDepositCheckout
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:304
* @route '/bookings/{booking}/handle-deposit-checkout'
*/
handleDepositCheckoutForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: handleDepositCheckout.url(args, options),
    method: 'post',
})

handleDepositCheckout.form = handleDepositCheckoutForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addBill
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:851
* @route '/bookings/{booking}/add-bill'
*/
export const addBill = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addBill.url(args, options),
    method: 'post',
})

addBill.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/add-bill',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addBill
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:851
* @route '/bookings/{booking}/add-bill'
*/
addBill.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return addBill.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addBill
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:851
* @route '/bookings/{booking}/add-bill'
*/
addBill.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addBill.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addBill
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:851
* @route '/bookings/{booking}/add-bill'
*/
const addBillForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addBill.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addBill
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:851
* @route '/bookings/{booking}/add-bill'
*/
addBillForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addBill.url(args, options),
    method: 'post',
})

addBill.form = addBillForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addCharges
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1005
* @route '/bookings/{booking}/add-charges'
*/
export const addCharges = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addCharges.url(args, options),
    method: 'post',
})

addCharges.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/add-charges',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addCharges
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1005
* @route '/bookings/{booking}/add-charges'
*/
addCharges.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return addCharges.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addCharges
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1005
* @route '/bookings/{booking}/add-charges'
*/
addCharges.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: addCharges.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addCharges
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1005
* @route '/bookings/{booking}/add-charges'
*/
const addChargesForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addCharges.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::addCharges
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:1005
* @route '/bookings/{booking}/add-charges'
*/
addChargesForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: addCharges.url(args, options),
    method: 'post',
})

addCharges.form = addChargesForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::updateCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:906
* @route '/bookings/{booking}/charges/{charge}'
*/
export const updateCharge = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateCharge.url(args, options),
    method: 'patch',
})

updateCharge.definition = {
    methods: ["patch"],
    url: '/bookings/{booking}/charges/{charge}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::updateCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:906
* @route '/bookings/{booking}/charges/{charge}'
*/
updateCharge.url = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            charge: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
        charge: args.charge,
    }

    return updateCharge.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{charge}', parsedArgs.charge.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::updateCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:906
* @route '/bookings/{booking}/charges/{charge}'
*/
updateCharge.patch = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: updateCharge.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::updateCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:906
* @route '/bookings/{booking}/charges/{charge}'
*/
const updateChargeForm = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateCharge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::updateCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:906
* @route '/bookings/{booking}/charges/{charge}'
*/
updateChargeForm.patch = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateCharge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateCharge.form = updateChargeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::removeCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:961
* @route '/bookings/{booking}/charges/{charge}'
*/
export const removeCharge = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: removeCharge.url(args, options),
    method: 'delete',
})

removeCharge.definition = {
    methods: ["delete"],
    url: '/bookings/{booking}/charges/{charge}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::removeCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:961
* @route '/bookings/{booking}/charges/{charge}'
*/
removeCharge.url = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            booking: args[0],
            charge: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
        charge: args.charge,
    }

    return removeCharge.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace('{charge}', parsedArgs.charge.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::removeCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:961
* @route '/bookings/{booking}/charges/{charge}'
*/
removeCharge.delete = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: removeCharge.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::removeCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:961
* @route '/bookings/{booking}/charges/{charge}'
*/
const removeChargeForm = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: removeCharge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingPaymentController::removeCharge
* @see app/Http/Controllers/Admin/Bookings/BookingPaymentController.php:961
* @route '/bookings/{booking}/charges/{charge}'
*/
removeChargeForm.delete = (args: { booking: string | number, charge: string | number } | [booking: string | number, charge: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: removeCharge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

removeCharge.form = removeChargeForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateNotes
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:346
* @route '/bookings/{booking}/notes'
*/
export const updateNotes = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateNotes.url(args, options),
    method: 'put',
})

updateNotes.definition = {
    methods: ["put"],
    url: '/bookings/{booking}/notes',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateNotes
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:346
* @route '/bookings/{booking}/notes'
*/
updateNotes.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return updateNotes.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateNotes
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:346
* @route '/bookings/{booking}/notes'
*/
updateNotes.put = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateNotes.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateNotes
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:346
* @route '/bookings/{booking}/notes'
*/
const updateNotesForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateNotes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateNotes
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:346
* @route '/bookings/{booking}/notes'
*/
updateNotesForm.put = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateNotes.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateNotes.form = updateNotesForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateSpecialRequests
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:388
* @route '/bookings/{booking}/special-requests'
*/
export const updateSpecialRequests = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateSpecialRequests.url(args, options),
    method: 'put',
})

updateSpecialRequests.definition = {
    methods: ["put"],
    url: '/bookings/{booking}/special-requests',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateSpecialRequests
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:388
* @route '/bookings/{booking}/special-requests'
*/
updateSpecialRequests.url = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { booking: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.id
        : args.booking,
    }

    return updateSpecialRequests.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateSpecialRequests
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:388
* @route '/bookings/{booking}/special-requests'
*/
updateSpecialRequests.put = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: updateSpecialRequests.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateSpecialRequests
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:388
* @route '/bookings/{booking}/special-requests'
*/
const updateSpecialRequestsForm = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateSpecialRequests.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::updateSpecialRequests
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:388
* @route '/bookings/{booking}/special-requests'
*/
updateSpecialRequestsForm.put = (args: { booking: string | { id: string } } | [booking: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: updateSpecialRequests.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

updateSpecialRequests.form = updateSpecialRequestsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::assignRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:251
* @route '/bookings/{booking}/assign-rooms'
*/
export const assignRooms = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assignRooms.url(args, options),
    method: 'post',
})

assignRooms.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/assign-rooms',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::assignRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:251
* @route '/bookings/{booking}/assign-rooms'
*/
assignRooms.url = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: args.booking,
    }

    return assignRooms.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::assignRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:251
* @route '/bookings/{booking}/assign-rooms'
*/
assignRooms.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: assignRooms.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::assignRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:251
* @route '/bookings/{booking}/assign-rooms'
*/
const assignRoomsForm = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assignRooms.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::assignRooms
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:251
* @route '/bookings/{booking}/assign-rooms'
*/
assignRoomsForm.post = (args: { booking: string | number } | [booking: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: assignRooms.url(args, options),
    method: 'post',
})

assignRooms.form = assignRoomsForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
export const roomHistory = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomHistory.url(args, options),
    method: 'get',
})

roomHistory.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/room-history',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
roomHistory.url = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'booking_reference' in args) {
        args = { booking: args.booking_reference }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
    }

    return roomHistory.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
roomHistory.get = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: roomHistory.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
roomHistory.head = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: roomHistory.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
const roomHistoryForm = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomHistory.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
roomHistoryForm.get = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomHistory.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingController::roomHistory
* @see app/Http/Controllers/Admin/Bookings/BookingController.php:829
* @route '/bookings/{booking}/room-history'
*/
roomHistoryForm.head = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: roomHistory.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

roomHistory.form = roomHistoryForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
export const calculateExtension = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calculateExtension.url(args, options),
    method: 'get',
})

calculateExtension.definition = {
    methods: ["get","head"],
    url: '/bookings/{booking}/calculate-extension',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
calculateExtension.url = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'booking_reference' in args) {
        args = { booking: args.booking_reference }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
    }

    return calculateExtension.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
calculateExtension.get = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: calculateExtension.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
calculateExtension.head = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: calculateExtension.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
const calculateExtensionForm = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calculateExtension.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
calculateExtensionForm.get = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calculateExtension.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::calculateExtension
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:30
* @route '/bookings/{booking}/calculate-extension'
*/
calculateExtensionForm.head = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: calculateExtension.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

calculateExtension.form = calculateExtensionForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::extend
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:102
* @route '/bookings/{booking}/extend'
*/
export const extend = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: extend.url(args, options),
    method: 'post',
})

extend.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/extend',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::extend
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:102
* @route '/bookings/{booking}/extend'
*/
extend.url = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'booking_reference' in args) {
        args = { booking: args.booking_reference }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
    }

    return extend.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::extend
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:102
* @route '/bookings/{booking}/extend'
*/
extend.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: extend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::extend
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:102
* @route '/bookings/{booking}/extend'
*/
const extendForm = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: extend.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::extend
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:102
* @route '/bookings/{booking}/extend'
*/
extendForm.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: extend.url(args, options),
    method: 'post',
})

extend.form = extendForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::modifyDates
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:187
* @route '/bookings/{booking}/modify-dates'
*/
export const modifyDates = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: modifyDates.url(args, options),
    method: 'post',
})

modifyDates.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/modify-dates',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::modifyDates
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:187
* @route '/bookings/{booking}/modify-dates'
*/
modifyDates.url = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'booking_reference' in args) {
        args = { booking: args.booking_reference }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
    }

    return modifyDates.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::modifyDates
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:187
* @route '/bookings/{booking}/modify-dates'
*/
modifyDates.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: modifyDates.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::modifyDates
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:187
* @route '/bookings/{booking}/modify-dates'
*/
const modifyDatesForm = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: modifyDates.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingStayController::modifyDates
* @see app/Http/Controllers/Admin/Bookings/BookingStayController.php:187
* @route '/bookings/{booking}/modify-dates'
*/
modifyDatesForm.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: modifyDates.url(args, options),
    method: 'post',
})

modifyDates.form = modifyDatesForm

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
export const data = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: data.url(args, options),
    method: 'get',
})

data.definition = {
    methods: ["get","head"],
    url: '/bookings/{reference}/data',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
data.url = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { reference: args }
    }

    if (Array.isArray(args)) {
        args = {
            reference: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        reference: args.reference,
    }

    return data.definition.url
            .replace('{reference}', parsedArgs.reference.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
data.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: data.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
data.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: data.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
const dataForm = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: data.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
dataForm.get = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: data.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\BookingDataController::data
* @see app/Http/Controllers/Admin/Bookings/BookingDataController.php:137
* @route '/bookings/{reference}/data'
*/
dataForm.head = (args: { reference: string | number } | [reference: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: data.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

data.form = dataForm

const bookings = {
    roomAvailability: Object.assign(roomAvailability, roomAvailability),
    roomPricing: Object.assign(roomPricing, roomPricing),
    getAvailableRooms: Object.assign(getAvailableRooms, getAvailableRooms),
    calculatePricing: Object.assign(calculatePricing, calculatePricing),
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    incidentals: Object.assign(incidentals, incidentals),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    availableRooms: Object.assign(availableRooms, availableRooms),
    assignedRooms: Object.assign(assignedRooms, assignedRooms),
    checkin: Object.assign(checkin, checkin),
    checkout: Object.assign(checkout, checkout),
    cancel: Object.assign(cancel, cancel),
    noShow: Object.assign(noShow, noShow),
    otaNoShow: Object.assign(otaNoShow, otaNoShow),
    virtualCard: Object.assign(virtualCard, virtualCard),
    collectPayment: Object.assign(collectPayment, collectPayment),
    sendPaymentLink: Object.assign(sendPaymentLink, sendPaymentLink),
    generatePaymentLink: Object.assign(generatePaymentLink, generatePaymentLink),
    refund: Object.assign(refund, refund),
    payments: Object.assign(payments, payments),
    collectDeposit: Object.assign(collectDeposit, collectDeposit),
    collectPaymentWithDeposit: Object.assign(collectPaymentWithDeposit, collectPaymentWithDeposit),
    handleDepositCheckout: Object.assign(handleDepositCheckout, handleDepositCheckout),
    addBill: Object.assign(addBill, addBill),
    addCharges: Object.assign(addCharges, addCharges),
    updateCharge: Object.assign(updateCharge, updateCharge),
    removeCharge: Object.assign(removeCharge, removeCharge),
    updateNotes: Object.assign(updateNotes, updateNotes),
    updateSpecialRequests: Object.assign(updateSpecialRequests, updateSpecialRequests),
    assignRooms: Object.assign(assignRooms, assignRooms),
    changeRoom: Object.assign(changeRoom, changeRoom),
    changeRoomType: Object.assign(changeRoomType, changeRoomType),
    items: Object.assign(items, items),
    roomHistory: Object.assign(roomHistory, roomHistory),
    calculateExtension: Object.assign(calculateExtension, calculateExtension),
    extend: Object.assign(extend, extend),
    modifyDates: Object.assign(modifyDates, modifyDates),
    activities: Object.assign(activities, activities),
    data: Object.assign(data, data),
}

export default bookings